import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import ReportHeader from "../../../../Components/ReportHeader";
import { useGenerateReportMutation } from "../../../../features/Report/reportSlice";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import * as XLSX from "xlsx";
import html2pdf from 'html2pdf.js'; // Import html2pdf.js
import { jsPDF } from "jspdf"; // Import jsPDF
import "jspdf-autotable";
import { utils, writeFile } from "xlsx";



const Report4 = () => {
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const year = queryParams.get("year")
    const ReportType = queryParams.get("reportType")
    const GrpID = queryParams.get("groupId")
    const rows = Array(7).fill();
    const rowsCs = Array(5).fill();
    const [generateReport, { data: reportData, error, isLoading: reportLoading }] = useGenerateReportMutation();

    console.log("REPORT", reportData)




    useEffect(() => {
        const handleReportGeneration = async () => {
            try {
                await generateReport({
                    year,
                    reportType: ReportType,
                    groupId: GrpID,
                }).unwrap();
            } catch (err) {
                console.error("Error generating report:", err);
            }
        };
        handleReportGeneration();
    }, [year, ReportType, GrpID, generateReport]);

    if (reportLoading) return <div style={{ height: "100vh", display: "flex", justifyContent: "center", alignItems: "center", fontWeight: "600", fontSize: "20px" }}>Loading...</div>;
    if (error) return <div style={{ height: "100vh", overflow: 'auto', display: "flex", justifyContent: "center", alignItems: "center" }} id="modal_body">
        <div style={{ fontSize: "20px", fontWeight: "600", color: "#000000" }}>No Record Found !</div>
    </div>;


    const tableHeadReport1 = [
        { label: "" },
        { label: `MWBE Procurement` },
        { label: "WBE Procurement" },
        { label: "Combined Women Procurement" },
        { label: `${year} Total Corporate Procurement` },
    ];


    const handleTitlevalue = () => {
        switch (ReportType) {
            case "Report_1a_Large":
                return "Table 1A"
            case "Report_1a_Small":
                return "Table 1B"
            case "Report_1a_CCA":
                return "Table 1C"
            case "Report_2a_TotalSpend":
                return "Table 2A"
            case "Report_2a_Subcontracting":
                return "Table 2B"
            case "Report_3a_Large":
                return "Table 3A"
            case "Report_3b_Small":
                return "Table 3B"
            case "Report_3c_Large":
                return "Table 3C"
            case "Report_3d_Small":
                return "Table 3D"
            case "Report_4a_Large":
                return "Table 4A"
            case "Report_4a_Small":
                return "Table 4B"
            case "Report_5a_DVBE":
                return "Table 5A"
            case "Report_5a_LGBTBE":
                return "Table 5B"
            default:
                return "Table";
        }
    }

    const handleText = (value, company) => {
        // console.log("COM", company)
        switch (value) {
            case 0:
                return company
            case 1:
                return "Direct"
            case 2:
                return ""
            case 3:
                return "Subcontracting"
            case 4:
                return ""
            case 5:
                return "Combined"
            case 6:
            default:
                return ""
        }
    }
    const handleTextCell1 = (value, data) => {
        // console.log("COM", company)
        switch (value) {
            case 0:
                return ""
            case 1:
                return ""
            case 2:
                return ""
            case 3:
                return ""
            case 4:
                return ""
            case 5:
                return data?.TotalProcurement
            case 6:
            default:
                return "100%"
        }
    }

    const handleCommonCell = (value, data, key) => {
        // console.log("COM", company)
        switch (value) {
            case 0:
                return "";
            case 1:
                return data?.[key]?.direct;
            case 2:
                return data?.[key]?.directPercentage;
            case 3:
                return data?.[key]?.subcontracting;
            case 4:
                return data?.[key]?.subcontractingPercentage;
            case 5:
                return data?.[key]?.combined;
            case 6:
            default:
                return data?.[key]?.combinedPercentage;
        }

    }

    const generatePDF = () => {
        const doc = new jsPDF();
    
        const addHeader = (doc) => {
            doc.setFontSize(16);
            doc.setTextColor(40);
            doc.text(handleTitlevalue(), 14, 10); // Title
    
            doc.setFontSize(10);
            doc.setTextColor(60);
            doc.text(handleTitle(), 14, 16, { maxWidth: 180 }); // Description
    
            doc.setLineWidth(0.5);
        };
    
        // Initial header
        addHeader(doc);
    
        let startY = 28; // Starting Y-axis for the first table
    
        reportData?.data?.reportData?.forEach((itm, idx) => {
            const tableHead = [
                ["", "MWBE Procurement", "WBE Procurement", "Combined Women Procurement", `${year} Total Corporate Procurement`],
            ];
    
            const tableBody = rows.map((row, ix) =>
                Array(5)
                    .fill(null)
                    .map((_, cellIndex) => {
                        switch (cellIndex) {
                            case 0:
                                return handleText(ix, itm?.CompanyName); // First column
                            case 1:
                                return handleCommonCell(ix, itm, "MWBE_procurement");
                            case 2:
                                return handleCommonCell(ix, itm, "WBE_procurement");
                            case 3:
                                return handleCommonCell(ix, itm, "Combined_Women_Procurement");
                            case 4:
                                return handleTextCell1(ix, itm);
                            default:
                                return null;
                        }
                    })
            );
    
            // Add summary rows
            const summaryRows = [
                ["Total", reportData?.data?.reportDetails?.MWBE || "-", reportData?.data?.reportDetails?.WBE || "-", reportData?.data?.reportDetails?.CombinedWomen || "-", reportData?.data?.reportDetails?.TotalProcurement || "-"],
                ["", reportData?.data?.reportDetails?.MWBEPercentage || "-", reportData?.data?.reportDetails?.WBEPercentage || "-", reportData?.data?.reportDetails?.CombinedWomenPercentage || "-", "100%"],
            ];
    
            tableBody.push(...summaryRows);
    
            // Table options
            const tableOptions = {
                startY: startY,
                head: tableHead,
                body: tableBody,
                showHead: "firstPage",
                styles: { fontSize: 8, cellPadding: 4 },
                headStyles: { fillColor: [233, 248, 255], textColor: "#000", fontStyle: "bold" },
                bodyStyles: { textColor: "#1A1A1A" },
            };
    
            // Add table
            doc.autoTable(tableOptions);
    
            // ✅ Update startY for next table based on the last Y position
            startY = doc.lastAutoTable.finalY + 20;
    
            // ✅ Add a new page if content exceeds the page height
            if (startY > 270) { // jsPDF page height ~297mm, leaving some margin
                doc.addPage();
                startY = 28; // Reset startY for new page
            }
        });
    
        // Save the PDF
        doc.save("Report.pdf");
    };



    // const generatePDF = () => {
    //     const doc = new jsPDF();

    //     // Add a header to the PDF
    //     doc.setFontSize(18);
    //     doc.text("", 14, 15);

    //     // Loop through `reportData` and create tables
    //     reportData?.data?.reportData?.forEach((itm, idx) => {
    //         const tableHead = [
    //             [
    //                 "",
    //                 `MWBE Procurement`,
    //                 "WBE Procurement",
    //                 "Combined Women Procurement",
    //                 `${year} Total Corporate Procurement`,
    //             ], // Replace with dynamic headers (tableHeadReport1)
    //         ];

    //         //     MWBE Procurement` },
    //         // { label: "WBE Procurement" },
    //         // { label: "Combined Women Procurement" },
    //         // { label: `${year} Total Corporate Procurement` 

    //         const tableBody = rows.map((row, ix) =>
    //             Array(5)
    //                 .fill(null)
    //                 .map((_, cellIndex) => {
    //                     switch (cellIndex) {
    //                         case 0:
    //                             return handleText(ix, itm?.CompanyName); // Customize for the first cell

    //                         case 1:
    //                             return handleCommonCell(ix, itm, "MWBE_procurement");
    //                         case 2:
    //                             return handleCommonCell(ix, itm, "WBE_procurement");
    //                         case 3:
    //                             return handleCommonCell(ix, itm, "Combined_Women_Procurement");
    //                         case 4:
    //                             return handleTextCell1(ix, itm);
    //                         default:
    //                             return null;
    //                     }
    //                 })
    //         );

    //         // Customize table styles
    //         const tableOptions = {
    //             startY: idx === 0 ? 20 : doc.previousAutoTable.finalY + 20, // Position for multiple tables
    //             head: tableHead,
    //             body: tableBody,
    //             showHead: "firstPage",
    //             styles: {
    //                 fontSize: 8,
    //                 cellPadding: 4,
    //             },
    //             headStyles: {
    //                 fillColor: [233, 248, 255], // Light blue background
    //                 textColor: "#000",
    //                 fontStyle: "bold",
    //             },
    //             bodyStyles: {
    //                 textColor: "#1A1A1A",
    //             },
    //             // alternateRowStyles: {
    //             //     fillColor: [246, 246, 246], // Light gray
    //             // },
    //         };

    //         // Add table to PDF
    //         doc.autoTable(tableOptions);
    //     });

    //     // Save the PDF
    //     doc.save("Report.pdf");
    // }

    // const generatePDF = () => {
    //     const doc = new jsPDF();

    //     const addHeader = (doc) => {
    //         doc.setFontSize(16);
    //         doc.setTextColor(40);
    //         doc.text(handleTitlevalue(), 14, 10); // Title

    //         doc.setFontSize(10);
    //         doc.setTextColor(60);
    //         doc.text(
    //             handleTitle(),
    //             14,
    //             16,
    //             { maxWidth: 180 }
    //         ); // Description (wrapped text)

    //         doc.setLineWidth(0.5);
    //         // doc.line(10, 22, 200, 22); // Horizontal line
    //     };

    //     // Call the header function for the first page
    //     addHeader(doc);

    //     let startY = 28;

    //     reportData?.data?.reportData?.forEach((itm, idx) => {
    //         const tableHead = [
    //             [
    //                 "",
    //                 `MWBE Procurement`,
    //                 "WBE Procurement",
    //                 "Combined Women Procurement",
    //                 `${year} Total Corporate Procurement`,
    //             ],
    //         ];

    //         const tableBody = rows.map((row, ix) =>
    //             Array(5)
    //                 .fill(null)
    //                 .map((_, cellIndex) => {
    //                     switch (cellIndex) {
    //                         case 0:
    //                             return handleText(ix, itm?.CompanyName); // First column
    //                         case 1:
    //                             return handleCommonCell(ix, itm, "MWBE_procurement");
    //                         case 2:
    //                             return handleCommonCell(ix, itm, "WBE_procurement");
    //                         case 3:
    //                             return handleCommonCell(ix, itm, "Combined_Women_Procurement");
    //                         case 4:
    //                             return handleTextCell1(ix, itm);
    //                         default:
    //                             return null;
    //                     }
    //                 })
    //         );

    //         // Add "Total" and percentage row at the bottom of the table
    //         const summaryRows = [
    //             [
    //                 "Total",
    //                 reportData?.data?.reportDetails?.MWBE || "-",
    //                 reportData?.data?.reportDetails?.WBE || "-",
    //                 reportData?.data?.reportDetails?.CombinedWomen || "-",
    //                 reportData?.data?.reportDetails?.TotalProcurement || "-",
    //             ],
    //             [
    //                 "",
    //                 reportData?.data?.reportDetails?.MWBEPercentage || "-",
    //                 reportData?.data?.reportDetails?.WBEPercentage || "-",
    //                 reportData?.data?.reportDetails?.CombinedWomenPercentage || "-",
    //                 "100%",
    //             ],
    //         ];

    //         // Append summary rows to tableBody
    //         tableBody.push(...summaryRows);

    //         // Customize table styles
    //         const tableOptions = {
    //             startY: startY,
    //             // startY: idx === 0 ? 20 : doc.previousAutoTable.finalY + 20,
    //             head: tableHead,
    //             body: tableBody,
    //             showHead: "firstPage",
    //             styles: {
    //                 fontSize: 8,
    //                 cellPadding: 4,
    //             },
    //             headStyles: {
    //                 fillColor: [233, 248, 255], // Light blue background
    //                 textColor: "#000",
    //                 fontStyle: "bold",
    //             },
    //             bodyStyles: {
    //                 textColor: "#1A1A1A",
    //             },
    //         };

    //         // Add table to PDF
    //         doc.autoTable(tableOptions);
    //     });

    //     // Save the PDF
    //     doc.save("Report.pdf");
    // };

    // const generateCSV = () => {
    //     const csvRows = [];

    //     // Define the header row
    //     const header = ["", "MWBE Procurement", "WBE Procurement", "Combined Women Procurement", `${year} Total Corporate Procurement`];
    //     csvRows.push(header.join(","));

    //     // Loop through the reportData and build the rows
    //     reportData?.data?.reportData?.forEach((itm) => {
    //         rows.forEach((row, ix) => {
    //             const rowData = [
    //                 handleText(ix, itm?.CompanyName), // CompanyName
    //                 handleCommonCell(ix, itm, "MWBE_procurement"),
    //                 handleCommonCell(ix, itm, "WBE_procurement"),
    //                 handleCommonCell(ix, itm, "Combined_Women_Procurement"),
    //                 handleTextCell1(ix, itm),
    //             ];

    //             // Wrap each cell value in double quotes to handle commas in data
    //             const quotedRowData = rowData.map(cell => `"${cell}"`);

    //             // Add the row to the CSV data
    //             csvRows.push(quotedRowData.join(","));

    //             csvRows.push("");
    //         });
    //     });

    //     // Create a CSV blob
    //     const csvBlob = new Blob([csvRows.join("\n")], { type: 'text/csv;charset=utf-8;' });

    //     // Create an anchor tag to trigger the download
    //     const link = document.createElement("a");
    //     if (link.download !== undefined) {
    //         // Create a URL for the CSV Blob
    //         const url = URL.createObjectURL(csvBlob);
    //         link.setAttribute("href", url);
    //         link.setAttribute("download", "Report.csv");
    //         document.body.appendChild(link);
    //         link.click();
    //         document.body.removeChild(link);
    //     }
    // };


    const generateCSV = () => {
        let csvContent = "";

        const title = handleTitlevalue()
        const description = handleTitle()

        csvContent += `${title}\n${description}\n\n`; // Add title, description, and spacing

        //  Add CSV Header only once
        const headers = [
            "",
            "MWBE Procurement",
            "WBE Procurement",
            "Combined Women Procurement",
            `${year} Total Corporate Procurement`,
        ];
        csvContent += headers.map(value => `"${value}"`).join(",") + "\n"; // Convert to CSV format



        // Loop through report data to add rows
        reportData?.data?.reportData?.forEach((itm, idx) => {
            const tableRows = rows.map((row, ix) =>
                [
                    handleText(ix, itm?.CompanyName),
                    handleCommonCell(ix, itm, "MWBE_procurement"),
                    handleCommonCell(ix, itm, "WBE_procurement"),
                    handleCommonCell(ix, itm, "Combined_Women_Procurement"),
                    handleTextCell1(ix, itm),
                ]
                    .map(value => `"${value}"`) // Ensure values stay within a single cell
                    .join(",")
            );

            csvContent += tableRows.join("\n") + "\n"; // Append data rows

            csvContent += "\n";
        });

        //  Add Summary Rows **only once** at the bottom
        const summaryRows = [
            [
                "Total",
                reportData?.data?.reportDetails?.MWBE || "-",
                reportData?.data?.reportDetails?.WBE || "-",
                reportData?.data?.reportDetails?.CombinedWomen || "-",
                reportData?.data?.reportDetails?.TotalProcurement || "-",
            ].map(value => `"${value}"`).join(","),

            [
                "",
                reportData?.data?.reportDetails?.MWBEPercentage || "-",
                reportData?.data?.reportDetails?.WBEPercentage || "-",
                reportData?.data?.reportDetails?.CombinedWomenPercentage || "-",
                "100%",
            ].map(value => `"${value}"`).join(","),
        ];

        csvContent += summaryRows.join("\n") + "\n"; // Append summary at the end

        //  Download CSV as a file
        const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.setAttribute("download", "Report.csv");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };
    const generateXLSX = () => {
        let worksheetData = [];

        const title = [handleTitlevalue()];
        const description = [handleTitle()];

        worksheetData.push(title);
        worksheetData.push(description);
        worksheetData.push([]); // Empty row for spacing

        // ✅ Add Header (only once)
        const headers = [
            "",
            "MWBE Procurement",
            "WBE Procurement",
            "Combined Women Procurement",
            `${year} Total Corporate Procurement`,
        ];
        worksheetData.push(headers);

        // ✅ Loop through report data and add rows
        reportData?.data?.reportData?.forEach((itm, idx) => {
            const tableRows = rows.map((row, ix) => [
                handleText(ix, itm?.CompanyName),
                handleCommonCell(ix, itm, "MWBE_procurement"),
                handleCommonCell(ix, itm, "WBE_procurement"),
                handleCommonCell(ix, itm, "Combined_Women_Procurement"),
                handleTextCell1(ix, itm),
            ]);

            worksheetData.push(...tableRows);

            // ✅ Add an empty row after each forEach iteration
            worksheetData.push([]);
        });

        // ✅ Add Summary Rows **only once** at the bottom
        worksheetData.push([
            "Total",
            reportData?.data?.reportDetails?.MWBE || "-",
            reportData?.data?.reportDetails?.WBE || "-",
            reportData?.data?.reportDetails?.CombinedWomen || "-",
            reportData?.data?.reportDetails?.TotalProcurement || "-",
        ]);

        worksheetData.push([
            "",
            reportData?.data?.reportDetails?.MWBEPercentage || "-",
            reportData?.data?.reportDetails?.WBEPercentage || "-",
            reportData?.data?.reportDetails?.CombinedWomenPercentage || "-",
            "100%",
        ]);

        // ✅ Create XLSX workbook and worksheet
        const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Report");

        // ✅ Save the XLSX file
        XLSX.writeFile(workbook, "Report.xlsx");
    };
    const downloadHandle = (val) => {
        console.log("VL", val)
        if (val === 1) {
            generatePDF()
        }
        if (val === 2) {
            generateXLSX()
            // downloadExcel()
        }
        if (val === 3) {
            generateCSV()
        }

    }



    const handleTitle = () => {
        if (ReportType === "Report_4a_Large") {
            return "Summary of Large Utilities Procurement from Women Business Enterprises"
        }
        if (ReportType === "Report_4b_Small") {
            return "Summary of Small Utilities Procurement from Women Business Enterprises"
        }
    }


    return (
        <div id="report_generation">
            <ReportHeader handleClick={reportData?.data?.reportData?.length < 1 ? () => { } : downloadHandle} title={handleTitle()} year={year} report={ReportType}  logo={reportData?.data?.logo}/>
            {reportData?.data?.reportData?.length < 1 ?
                <div style={{ height: "calc(100vh - 225px)", overflow: 'auto', display: "flex", justifyContent: "center", alignItems: "center" }} id="modal_body">
                    <div style={{ fontSize: "20px", fontWeight: "600", color: "#000000" }}>No Record Found !</div>
                </div>
                :
                <div style={{ height: "calc(100vh - 225px)", overflow: 'auto' }} id="modal_body">
                    {reportData?.data?.reportData?.map((itm, idx) => {
                        return (
                            <TableContainer component={Paper} sx={{ marginTop: idx > 0 ? "24px" : "0px" }}>
                                {/* {console.log(data, "data")} */}
                                <Table aria-label='customized table'>
                                    <TableHead>
                                        <TableRow>
                                            {tableHeadReport1.map((header, id) => (
                                                <TableCell
                                                    key={id}
                                                    align='center'
                                                    style={{
                                                        background: id === 0 ? "#fff" : "#E9F8FF",
                                                        fontWeight: "500",
                                                        color: "#000000",
                                                        fontSize: "16px",
                                                        letterSpacing: "0.2px"
                                                    }}>
                                                    {header.label}
                                                </TableCell>
                                            ))}
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {/* {data?.currentRows.map((row, id) => ( */}
                                        {rows.map((item, ix) => {
                                            {/* console.log(itm?.companyName,itm,"CPP") */ }
                                            return (
                                                <TableRow sx={{
                                                    height: "62px",

                                                }}>

                                                    {Array(5) // Assuming there are 9 cells in each row
                                                        .fill(null)
                                                        .map((_, cellIndex) => {
                                                            // Handle cell-specific logic with a switch case
                                                            const cellContent = (() => {
                                                                switch (cellIndex) {
                                                                    case 0:
                                                                        return handleText(ix, itm?.CompanyName); // Customize for the first cell

                                                                    case 1:
                                                                        return handleCommonCell(ix, itm, "MWBE_procurement");
                                                                    case 2:
                                                                        return handleCommonCell(ix, itm, "WBE_procurement");
                                                                    case 3:
                                                                        return handleCommonCell(ix, itm, "Combined_Women_Procurement");
                                                                    case 4:
                                                                        return handleTextCell1(ix, itm);
                                                                    default:
                                                                        return null; // Default for cells without specific logic
                                                                }
                                                            })();

                                                            // Additional cell styles based on `cellIndex`
                                                            const cellStyle = {
                                                                fontWeight: cellIndex === 0 ? "700" : "400",
                                                                fontSize: "14px",
                                                                color: "#1A1A1A",
                                                                textAlign: ix === 0 && cellIndex === 0 ? "left" : "right",
                                                                border: "1px solid #E6E6E6", // Add border to each cell
                                                                borderTop:
                                                                    ix === 0 && cellIndex === 0
                                                                        ? "none"
                                                                        : "1px solid #E6E6E6", // Remove borderTop only for the first cell of the first row
                                                                backgroundColor:
                                                                    ix === 3 || ix === 4 ? "#F6F6F6" : "transparent", // Conditional background color
                                                            };

                                                            return (
                                                                <TableCell sx={cellStyle} key={cellIndex}>
                                                                    {cellContent}
                                                                </TableCell>
                                                            );
                                                        })}

                                                </TableRow>
                                            )

                                        })

                                        }
                                        {Array(2)
                                            .fill(null)
                                            .map((_, rowIndex) => {
                                                return (
                                                    <TableRow sx={{
                                                        height: "62px",

                                                    }}>
                                                        {Array(5) // Assuming there are 9 cells in each row
                                                            .fill(null)
                                                            .map((_, cellIndex) => {
                                                                // Handle cell-specific logic with a switch case
                                                                const cellContentData = (() => {
                                                                    switch (cellIndex) {
                                                                        case 0:
                                                                            return rowIndex === 0 ? "Total" : "" // Customize for the first cell

                                                                        case 1:
                                                                            return rowIndex === 0 ? reportData?.data?.reportDetails?.MWBE : reportData?.data?.reportDetails?.MWBEPercentage
                                                                        case 2:
                                                                            return rowIndex === 0 ? reportData?.data?.reportDetails?.WBE : reportData?.data?.reportDetails?.WBEPercentage

                                                                        case 3:
                                                                            return rowIndex === 0 ? reportData?.data?.reportDetails?.CombinedWomen : reportData?.data?.reportDetails?.CombinedWomenPercentage

                                                                        case 4:
                                                                            return rowIndex === 0 ? reportData?.data?.reportDetails?.TotalProcurement : "100%"
                                                                        default:
                                                                            return null; // Default for cells without specific logic
                                                                    }
                                                                })();

                                                                // Additional cell styles based on `cellIndex`
                                                                const cellStyle = {
                                                                    fontWeight: "700",
                                                                    fontSize: "14px",
                                                                    color: "#1A1A1A",
                                                                    textAlign: "right",
                                                                    border: "1px solid #E6E6E6", // Add border to each cell
                                                                    borderTop:
                                                                        "1px solid #E6E6E6", // Remove borderTop only for the first cell of the first row
                                                                    backgroundColor:
                                                                        "transparent", // Conditional background color
                                                                };

                                                                return (
                                                                    <TableCell sx={cellStyle} key={cellIndex}>
                                                                        {cellContentData}
                                                                    </TableCell>
                                                                );
                                                            })}
                                                    </TableRow>)
                                            }
                                            )}

                                    </TableBody>
                                </Table>
                            </TableContainer>
                        )
                    })
                    }

                </div>
            }
        </div>
    )
}

export default Report4